module.exports = __webpack_public_path__ + "img/0220805140215.d4e32c9e.jpg";